import { render } from "./Select.vue?vue&type=template&id=0c787d45"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"

import exportComponent from "/Users/christianbundgaard/dev/cbundgaard-bitbucket/artivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__